import { useEffect, useState } from "react";
import { Row, Col, Card, Container, Carousel } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";
import { formatDescription, getGameAssetsUrl } from "../utilities/Helpers";

const GameLibrary = () => {
    const navigate = useNavigate();
    const [games, setGames] = useState<Game[]>();
    const [selectedGame, setSelectedGame] = useState<Game>();

    useEffect(() => {
        ApiService.get('/games/library').then((response) => {
            if (!response) throw new Error('No response');
            if (!response.success) console.log(response.message);
            else {
                setGames(response.data);
            }
        }).catch((error: any) => {
            console.error(error);
        });
    }, []);

    const Library = () => {
        function handleSelectedGame(event: any) {
            event.preventDefault();
            //setSelectedGame(games?.find((game) => game.id === Number(event.currentTarget.value)));
            let game = games?.find((game) => game.id === Number(event.currentTarget.value));
            navigate(`/game/${game?.id}`);
        }

        if (!games) return <Col>Loading games...</Col>;
        if (games.length === 0) return <Col>No games found.</Col>;
        return (<>
            {games.map((game) => {
                if (!game) return (<></>);
                let icon = getGameAssetsUrl(game.id) + '/logo.png';
                return (
                    <Col key={game.id} xs={12} md={4}>
                        <button className={`dg-btn dg-btn-library-game w-100 ${(selectedGame?.id === game.id) ? 'selected' : ''}`} onClick={handleSelectedGame} value={game.id}>
                            <img src={icon} alt={game.name} width={250} />
                        </button>
                    </Col>
                )
            })}
        </>);
    }

    const GameInfo = () => {
        if (!selectedGame) return <></>;

        const gameAssetsUrl = getGameAssetsUrl(Number(selectedGame.id));

        return (
            <Card className="card-widget">
                <Card.Body>
                    <Row>
                        <Col md={4}>
                            <Card.Text className="fs-7">
                                <Row className="mb-3 text-center">
                                    <Col>
                                        <img src={`${gameAssetsUrl}/logo.png`} alt={selectedGame.name} height={64} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div dangerouslySetInnerHTML={{ __html: `${formatDescription(selectedGame.description)}` }} />
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col>
                                        Publisher: <a href={selectedGame.publisher.website} target="_blank" rel="noreferrer noopener" title={selectedGame.publisher.name} >{selectedGame.publisher.name}</a>
                                        <br />
                                        Release date: {selectedGame.releaseDate ? new Date(selectedGame.releaseDate).toLocaleDateString() : 'TBD'}
                                    </Col>
                                </Row>
                                <Row className="">
                                    <Col>
                                        <button onClick={() => navigate(`/game/${selectedGame.id}`)} className="dg-btn dg-btn-primary dg-btn-block text-light">Learn more</button>
                                    </Col>
                                </Row>
                            </Card.Text>
                        </Col>
                        <Col md={8} className="text-center">
                            <Carousel>
                                <Carousel.Item>
                                    <img src={`${gameAssetsUrl}/screenshot1.png`} alt="Screenshot 1" className="w-100" />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img src={`${gameAssetsUrl}/screenshot2.png`} alt="Screenshot 2" className="w-100" />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img src={`${gameAssetsUrl}/screenshot3.png`} alt="Screenshot 3" className="w-100" />
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }

    return <>
        <Helmet>
            <title>Darknet Games | Library</title>
        </Helmet>
        <div className="library mb-3">
            <Container>
                <Row className='g-3 mb-3'>
                    <Col>
                        <Card className='card-widget' id="library-widget">
                            <Card.Header>
                                <Card.Title className="text-light text-center fs-3 fs-3">
                                    Game Catalog
                                </Card.Title>
                            </Card.Header>
                            <Card.Body className="library-games text-center">
                                <Row className="g-3">
                                    <Library />
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <GameInfo />
                    </Col>
                </Row>
            </Container>
        </div>
    </>;
}

export default GameLibrary;